import { Component } from '@angular/core';

@Component({
    selector: 'tgf-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'tangilla_forms';
}
